var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5162 7.31372L9.88491 12.1562C9.80429 12.2636 9.70154 12.3523 9.58366 12.4166C9.46566 12.4808 9.33541 12.519 9.20141 12.5285C9.06754 12.5378 8.93316 12.5185 8.80729 12.4716C8.68154 12.4246 8.56729 12.3511 8.47241 12.2562L6.59741 10.3812",
    stroke: "#13D16A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1737 17C14.3158 17 17.6737 13.6421 17.6737 9.5C17.6737 5.35788 14.3158 2 10.1737 2C6.03158 2 2.67371 5.35788 2.67371 9.5C2.67371 13.6421 6.03158 17 10.1737 17Z",
    stroke: "#13D16A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.d582d33759a81baca8edf617bb4356a4.svg";
export { ForwardRef as ReactComponent };